module.exports = __webpack_public_path__ + "img/Ilustra.a716bc4c.svg";